import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { BasicService } from '../../../providers/basic';
import { environment as config } from '../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../../auth/auth.service';
import { FormBuilder, Validators } from '@angular/forms';
import { empty, merge } from 'ramda/es';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ISession } from '../../../models/session';

@Injectable()
export class UsersService extends BasicService {
  private API = config.sessions.url;
  private USER_API = config.users.url;
  public sessionForm = this.fb.group({
    name: ['', Validators.required],
    date: ['', Validators.required],
    description: ['', Validators.minLength(5)],
    shortUrl: ['']
  });

  constructor(
    protected auth: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp,
    private fb: FormBuilder
  ) {
    super(auth, translate);
  }

  public getSpecialUsers(id: string, notify: boolean = false) {
    return this.http
      .get(`${this.USER_API}/sessions/${id}/users/specials`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public addSpecialUsers(
    id: string,
    type: 'guest' | 'moderator' | 'powerUser' | 'videoOperator',
    data,
    notify: boolean = true
  ) {
    return this.http
      .post(`${this.USER_API}/sessions/${id}/users/specials/${type}`, data)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public editSpecialUsers(id: string, data, notify: boolean = true) {
    return this.http
      .put(`${this.USER_API}/sessions/${id}/users/specials/any`, data)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public getRegistration(id: string, notify: boolean = false) {
    return this.http
      .get(`${this.USER_API}/sessions/${id}/users/forms/registration`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public updateRegistration(session: ISession, data, notify: boolean = true) {
    return this.http
      .post(`${this.USER_API}/sessions/${session.id}/users/forms/registration`, data)
      .map(res => this.extractData(res, notify))
      .catch(err => {
        if (err.status === 409) {
          toastr.error(this.translate.instant('action.alreadyFilled'));
          return err;
        }
        return this.handleError(err);
      });
  }

  public getGenericLogin(id: string, notify: boolean = false) {
    return this.http
      .get(`${this.USER_API}/sessions/${id}/users/forms/unique`)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }

  public updateGenericLogin(session: ISession, data, notify: boolean = true) {
    return this.http
      .post(`${this.USER_API}/sessions/${session.id}/users/forms/unique`, data)
      .map(res => this.extractData(res, notify))
      .catch(err => this.handleError(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/users/users.service.ts